import { b2bApi } from 'shared/infrastructure/clients'

const getDocuments = ({ proposalId }) =>
  b2bApi.get(`/proposals/${proposalId}/documents`)

export { getDocuments }
